import {
  ADD_UPDATE_PIAGGIO_ITEMDETAILS_FAILURE,
  ADD_UPDATE_PIAGGIO_ITEMDETAILS_REQUEST,
  ADD_UPDATE_PIAGGIO_ITEMDETAILS_SUCCESS,
  FETCH_PIAGGIO_ITEMDETAILS_LIST_FAILURE,
  FETCH_PIAGGIO_ITEMDETAILS_LIST_REQUEST,
  FETCH_PIAGGIO_ITEMDETAILS_LIST_SUCCESS
} from "./actionTypes";
import { PiaggioItemDetailsState } from "./types";

// Initial state for item reducer
const initialItemDetailsState: PiaggioItemDetailsState = {
    piaggioItemDetailsList: [],
    loadingItemDetails: false,
    errorItemDetails: null,
    totalCountItemDetails: 0,
    successMessageItemDetails: null
};
//Item details reducer
const piaggioItemDetailsReducer = (
  state = initialItemDetailsState,
  action: any
): PiaggioItemDetailsState => {
  switch (action.type) {
    case FETCH_PIAGGIO_ITEMDETAILS_LIST_REQUEST:
      return {
        ...state,
        loadingItemDetails: true,
        errorItemDetails: null,
      };

    case FETCH_PIAGGIO_ITEMDETAILS_LIST_SUCCESS:
      return {
        ...state,
        loadingItemDetails: false,
        piaggioItemDetailsList: action.payload.piaggioItemDetailsList || action.payload,
        totalCountItemDetails: action.payload.totalCount || 0,
      };

    case FETCH_PIAGGIO_ITEMDETAILS_LIST_FAILURE:
      return {
        ...state,
        loadingItemDetails: false,
        errorItemDetails: action.payload,
      };

    case ADD_UPDATE_PIAGGIO_ITEMDETAILS_REQUEST:
      return {
        ...state,
        loadingItemDetails: true,
        errorItemDetails: null,
      };

    case ADD_UPDATE_PIAGGIO_ITEMDETAILS_SUCCESS:
      return {
        ...state,
        loadingItemDetails: false,
        successMessageItemDetails: action.payload,
      };

    case ADD_UPDATE_PIAGGIO_ITEMDETAILS_FAILURE:
      return {
        ...state,
        loadingItemDetails: false,
        errorItemDetails: action.payload,
      };

    default:
      return state;
  }
};

export default piaggioItemDetailsReducer;